<template>
  <div>
    <div>
      <h5 class="text-body">Deposit Limit History</h5>
    </div>
    <b-table
      :items="items"
      :fields="fields"
      responsive
      show-empty
      thead-class="text-nowrap"
      :busy="loadingDepositHistories"
    >
      <template #cell(amount)="{ item }">
        <span class="text-nowrap">{{
          formatCurrencyBuiltInFunc(item.newAmount)
        }}</span>
      </template>
      <template #cell(period)="{ item }">
        <span class="text-nowrap">{{
          formatPeriod(item.newPeriod) || "-"
        }}</span>
      </template>
      <template #cell(sources)="{ item }">
        <span class="text-nowrap">{{ item.sources || "OnSite" }}</span>
      </template>
      <template #cell(createdAt)="{ item }">
        <span class="text-nowrap"
          >{{ format(new Date(item.createdTime), "yyyy-MM-yy hh:mm:ss") }}
        </span>
      </template>
    </b-table>
    <div
      v-if="paginationDepositHistories.total > 0"
      class="d-flex align-items-center justify-content-between mt-1"
    >
      <div class="text-muted small">{{ paginationSummary }}</div>
      <div
        class="d-flex align-items-center justify-content-center justify-content-sm-end"
      >
        <b-pagination
          v-model="page"
          :total-rows="paginationDepositHistories.total"
          :per-page="paginationDepositHistories.limit"
          first-number
          last-number
          class="mb-0 mt-1 mt-sm-0"
          prev-class="prev-item"
          next-class="next-item"
        >
          <template #first-text
            ><span class="text-success">First</span></template
          >
          <template #prev-text>
            <feather-icon icon="ChevronLeftIcon" size="18" />
          </template>
          <template #next-text>
            <feather-icon icon="ChevronRightIcon" size="18" />
          </template>
          <template #last-text><span class="text-info">Last</span></template>
        </b-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { BTable, BPagination, BBadge } from "bootstrap-vue";
import { format } from "date-fns";
import { mapActions, mapState } from "vuex";
import { formatCurrencyBuiltInFunc } from "@/helpers/utils";

export default {
  components: {
    BTable,
    BPagination,
    BBadge,
  },
  data() {
    return {
      page: 1,
      fields: [
        { key: "amount", label: "Amount" },
        { key: "period", label: "Period" },
        { key: "source", label: "Source" },
        { key: "createdAt", label: "Created At" },
      ],
      items: [],
    };
  },
  watch: {
    page() {
      this.fetchDepositLimitHistories();
    },
  },
  computed: {
    ...mapState("user/detail", [
      "loadingDepositHistories",
      "paginationDepositHistories",
    ]),
    paginationSummary() {
      const p = this.paginationDepositHistories || {};
      const page = Number(p.page) || 1;
      const limit = Number(p.limit || p.perPage) || 10;
      const total = Number(p.total) || 0;

      const from = total === 0 ? 0 : (page - 1) * limit + 1;
      const to = total === 0 ? 0 : Math.min(page * limit, total);

      return total === 0
        ? `Showing 0 of 0 items`
        : `Showing ${from} - ${to} of ${total} items`;
    },
  },
  created() {
    this.fetchDepositLimitHistories();
  },
  methods: {
    ...mapActions("user/detail", ["getDepositsHistoryByUser"]),
    format,
    formatCurrencyBuiltInFunc,
    async fetchDepositLimitHistories() {
      const params = {
        userId: this.$route.params.id,
        page: this.page,
      };
      const result = await this.getDepositsHistoryByUser(params);
      if (result) this.items = result || [];
    },
    formatPeriod(period) {
      if (!period) return null;
      const periodMap = {
        1: "Daily",
        7: "Weekly",
        30: "Monthly",
      };
      return periodMap[period] || "-";
    },
  },
};
</script>
